import VForm from '@/vuetify_custom/v-form'
import { VCard, VCardTitle, VCardText } from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'
import {formattingNumber} from '@/libs/util'
import {AGREEMENT} from './constants'
import { common_mixins } from './EditMixIns.jsx'
import styles from './index.module.less'
export default {
    mixins:[common_mixins],
    computed: {
        have_paid_amount_total() {
         
            return this.params.expense_group_settlements.reduce((total, item) => {
                return math.eval(`${total}+${item.have_paid_amount || 0}`).toFixed(2)
            }, 0)
        },
        table_fields() {
            return [
                {
                    text: '履约批次',
                    align: 'center',
                    value: 'index',
                    type: 'button_g_field',
                    width: 90,
                    fixed: 'left',
                    render: (_, __, index) => {
                        return <div>
                       <span >{index + 1}</span>
                    </div>
                    }
                },
                {
                    text: '履约时间从',
                    align: 'center',
                    value: 'start_date',
                    width: 100,
                },
                {
                    text: '履约时间到',
                    align: 'center',
                    value: 'end_date',
                    width: 100,
                },
                {
                    text: '结算方式',
                    align: 'center',
                    type: 'list_field',
                    value: 'settlement_type',
                    item_key: 'key',
                    item_text: 'title',
                    width: 100,
                    items: [
                        {
                            title: '按约定比例',
                            key: AGREEMENT,
                        },
                        {
                            title: '按月',
                            key: 'per_month',
                        },
                        {
                            title: '按次',
                            key: 'per_time',
                        }
                    ]
                },
                {
                    text: '付款比例',
                    align: 'center',
                    value: 'settlement_percentage',
                    width: 100,
                },
                {
                    text: '约定付款金额',
                    align: 'center',
                    value: 'appoint_payment_amount',
                    width: 110,
                },
                {
                    text: '约定付款时间',
                    align: 'center',
                    value: 'payment_date',
                    width: 110,
                },
                {
                    text: '已支付金额（含本次）',
                    align: 'center',
                    value: 'have_paid_amount',
                    width: 110,
                },
                {
                    text: '本次需支付金额',
                    align: 'center',
                    value: 'payment_amount',
                    width: 110,
                    render:(_, __) => {
                        return <NumberField
                                v-model={__}
                                field={{
                                    key: 'payment_amount',
                                    // rules:[(val) => {
                                    //     if (Number(__.appoint_payment_amount || 0) < Number(math.eval(`${__.have_paid_amount || 0}+${Number(val)}`))) {
                                    //         return '本次需支付金额与已支付金额之和不能大于约定付款金额'
                                    //     }
                                    //     return true
                                    // }]
                                }}
                        />
                    }
                },
                {
                    text: '备注',
                    align: 'center',
                    value: 'desc',
                    width: 100,
                },
            ]
        },
        fields() {
            return [
                {
                    key:'table',
                    cols: 12,
                },
            ]
        }
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                合同结算款项
                <p class={styles['header-price']}>
                    合同总金额：
                    <span>
                        {formattingNumber(_this.params.hetong_total_price, 2)}
                    </span>
                </p>
                <p class={styles['header-price']}>
                    已支付金额合计：
                    <span>
                    {formattingNumber(_this.params.have_paid, 2)}
                        </span>
                </p>
            </VCardTitle>
            <VCardText>
            <VForm
                ref="base"
                fields={_this.fields}
                scopedSlots={{
                    table:() => {
                        return <VTable
                            headers={this.table_fields}
                            desserts={this.params.expense_group_settlements}
                        />
                    }
                }}
            />
            </VCardText>
        </VCard>
    </div>
    }
}   